import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { NotificationService } from '../../_services/notification.service';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { NgForm } from '@angular/forms';
import { ElasticSearchService } from '../../_services/elastic-search.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { UserService } from '../../_services/user.service';
import { DatabaseSnapshot } from 'angularfire2/database-deprecated/interfaces';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-reply-item',
  templateUrl: './reply-item.component.html',
  styleUrls: ['./reply-item.component.css'],
  inputs: ['post', 'reply', 'index'],
})
export class ReplyItemComponent implements OnInit {
  user: any;
  model: string;
  userId = this.userService.getUid();
  index: number;
  private subscription: Subscription = new Subscription();
  isEdit: boolean;
  _isLiked: boolean;
  @ViewChild("commentText") commentText: ElementRef;
  @ViewChild("f") form: NgForm;
  @Input() reply: any;
  @Input() post: any;
  constructor(private router: Router,
    public notificationService: NotificationService,
    private userService: UserService,
    private elasticSearchService: ElasticSearchService) {

  }
  ngOnInit() {
    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user;
    }));
    this._isLiked = this.isLiked();
  }
  focus() {
    this.commentText.nativeElement.classList.add("active");
  }
  submit() {
    this.isEdit = false;
    this.form.ngSubmit.emit();
  }
  commentKeyPress(event: KeyboardEvent) {
    if (event.keyCode === 13) {
      event.preventDefault();
      if (this.model.replace(/\s/g, '')) {
        this.submit();
      }

    }
  }
  delete() {
   
  }
  commentLikeLength() {
    return this.reply.likes ? this.reply.likes.length : 0;
  }
  isLiked(): boolean {
    try {
      return !this.post.replies.likes.every(like => like.username != this.user.username);
    } catch (e) {
      return false;
    }
  }

 

  navigate(username) {
    this.router.navigate(['/']).then(() => {
      this.router.navigate(['user/' + username]);
    });
  }

  
  public ngOnDestroy(): void {
    /*
     * magic kicks in here: All subscriptions which were added
     * with "subscription.add" are canceled too!
     */
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/post-item/reply-item/reply-item.component.ts